import React from 'react';
import './button.scss';


const Button = ({
  text,
  variant,
  onClick = () => {},
  icon,
  textStyle,
  disabled,
  link = false,
  href = ''

}) => {
  return (
    <button
    disabled={disabled}
    onClick={onClick}
    className={`btn-same button-${variant}`}
  >
    <div>{icon}</div>
    <div className={`button-${textStyle}`}>{text}</div>
  </button>
  );
};

export default Button;
